import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend"; // Add this
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpApi) // Use HTTP Backend to load translation files
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    fallbackLng: "de", // Default language
    supportedLngs: ["en", "de"], // Add your supported languages
    backend: {
      loadPath: "/locals/{{lng}}/{{ns}}.json", // Path to JSON files
    },
    ns: [
      "404",
      "aboutus",
      "cards",
      "categories",
      "certificates",
      "contactus",
      "contactuscard",
      "cookie-consent",
      "custimizationdiamond",
      "customizationsection",
      "diamondviewer",
      "footer",
      "fullpagesection",
      "header",
      "hero",
      "login",
      "productlistingpage",
      "statistics",
      "translation",
    ], // Namespaces (file names without extension)
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

export default i18n;
